

$(document).ready(function(){
  $(".owl-carousel").owlCarousel({
    items:4,
    autoPlay:true,
    nav:true,
    slideSpeed: 200,
    
    
  });
});

 $(document).ready(function() {
     $('.flexslider').flexslider({
     	
     	animation: "zoomin",
       controlNav:"false",
       slideshow:"false",
       animation: "fade"
     	

     });
    });
$(document).ready(function(){
  $("#brand-slider").owlCarousel({
    items:4,
	autoPlay:1000,
    
    
  });
});

                               

$(document).ready(function(){
    
  	$('#fblikes-counter').jQuerySimpleCounter({

			  start:  1,
			  end:    100,
			  duration: 5000,

		});
	  	$('#membership-counter').jQuerySimpleCounter({

			  start:  1,
			  end:    99,
			  duration: 5000,

		});
	  	$('#clients-counter').jQuerySimpleCounter({

			  start:  1,
			  end:    545,
			  duration: 5000,

		});
	  	$('#feedback-counter').jQuerySimpleCounter({

			  start:  1,
			  end:    100,
			  duration: 5000,

		});
	
	  });


$(function() {
    $( "#slider-range" ).slider({
      range: true,
      min: 0,
      max: 500,
      values: [ 100, 300 ],
      slide: function( event, ui ) {
        $( "#amount" ).html( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
        $( "#amount1" ).val(ui.values[ 0 ]);
        $( "#amount2" ).val(ui.values[ 1 ]);
      }
    });
    $( "#amount" ).html( "$" + $( "#slider-range" ).slider( "values", 0 ) +
     " - $" + $( "#slider-range" ).slider( "values", 1 ) );
  });
